import React from 'react';
import styles from './Footer.module.scss';
import cn from 'classnames';
import { ResetFilter } from '../../reset';
import RoundedButton from '../../../../../../components/RoundedButton/RoundedButton';
import { ReactComponent as ResetIcon } from '../../../../../../resource/ResetIcon.svg';
import SubmitFilter from '../../submit/ui';
import SaveFilter from '../../save';

const Footer = () => {
  return (
    <div className={styles.root}>
      <div className={styles.leftBlock}>
        <SubmitFilter
          render={({ onSubmit, ...props }) => (
            <RoundedButton
              type="primary"
              text="Применить"
              className={cn(styles.btn, styles.applyBtn)}
              onClick={onSubmit}
              {...props}
            />
          )}
        />
        <ResetFilter
          render={({ reset, ...props }) => (
            <RoundedButton
              text="Сбросить"
              className={cn(styles.btn, styles.resetBtn)}
              iconLeft={
                <ResetIcon style={{ cursor: 'pointer', fill: '#0995ed' }} />
              }
              onClick={reset}
            />
          )}
        />
      </div>
      <SaveFilter className={cn(styles.btn, styles.createBtn)} />
    </div>
  );
};

export default Footer;
